var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C12.1066 0 14.625 2.51838 14.625 5.625C14.625 8.73162 12.1066 11.25 9 11.25C5.89338 11.25 3.375 8.73162 3.375 5.625C3.375 2.51838 5.89338 0 9 0ZM15.4435 11.7359L12.9364 11.1091C10.3024 13.0037 7.10972 12.5809 5.06355 11.1091L2.55646 11.7359C1.05402 12.1115 0 13.4614 0 15.0101V16.3125C0 17.2445 0.755508 18 1.6875 18H16.3125C17.2445 18 18 17.2445 18 16.3125V15.0101C18 13.4614 16.946 12.1115 15.4435 11.7359Z",
    fill: "#59A3CF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientActive);
export default __webpack_public_path__ + "static/media/patient-active.b08dfa9e2a9ae856e464b838f3be9c84.svg";
export { ForwardRef as ReactComponent };